import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { AdminShell, adminPage } from '#/components/admin/admin-shell'
import { DataTable, Pager, SearchBox, fmtTokens } from '#/components/admin/ui'
import { Badge } from '#/components/ui/badge'
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '#/components/ui/sheet'
import { useAdminChat, useAdminChats, type AdminChatRow } from '#/lib/api-admin'
import { fmtDateTime, fmtNumber } from '#/lib/format'
import { cn } from '#/lib/utils'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/admin/chat')({ component: adminPage(Page) })

function Page() {
  const [q, setQ] = useState('')
  const [page, setPage] = useState(1)
  const [sel, setSel] = useState<string | null>(null)
  const { data, isLoading } = useAdminChats(q, page)
  const { data: detail } = useAdminChat(sel)
  return (
    <AdminShell title={m.admin_nav_chat()} description={m.admin_chat_desc()} actions={<SearchBox value={q} onChange={(v) => { setQ(v); setPage(1) }} placeholder={m.admin_plans_search()} />}>
      <DataTable<AdminChatRow>
        rows={data?.chats}
        loading={isLoading}
        rowKey={(c) => c.planId}
        onRow={(c) => setSel(c.planId)}
        cols={[
          { key: 'title', header: m.admin_col_title(), render: (c) => c.title },
          { key: 'user', header: m.admin_col_email(), render: (c) => c.userEmail },
          { key: 'n', header: m.admin_col_messages(), render: (c) => fmtNumber(c.messages), className: 'text-right tabular-nums' },
          { key: 'tok', header: m.admin_col_tokens(), render: (c) => `${fmtTokens(c.inputTokens)} / ${fmtTokens(c.outputTokens)}`, className: 'text-right tabular-nums' },
          { key: 'last', header: m.admin_col_last(), render: (c) => fmtDateTime(c.lastAt) },
        ]}
      />
      {data ? <Pager page={data.page} total={data.total} pageSize={data.pageSize} onPage={setPage} /> : null}
      <Sheet open={Boolean(sel)} onOpenChange={(o) => !o && setSel(null)}>
        <SheetContent className="w-full overflow-y-auto sm:max-w-2xl">
          <SheetHeader>
            <SheetTitle className="truncate">{detail?.plan.title ?? m.common_loading()}</SheetTitle>
            <SheetDescription>{detail?.plan.userEmail}</SheetDescription>
          </SheetHeader>
          <div className="space-y-3 px-4 pb-6">
            {detail?.messages.map((x) => (
              <div key={x.id} className={cn('rounded-lg border p-3 text-sm', x.role === 'user' ? 'bg-accent/40' : 'bg-card')}>
                <div className="mb-1 flex items-center gap-2 text-xs text-muted-foreground">
                  <Badge variant="outline">{x.role}</Badge>
                  {x.scope ? <span>{x.scope}</span> : null}
                  <span className="ml-auto tabular-nums">{x.inputTokens || x.outputTokens ? `${fmtTokens(x.inputTokens ?? 0)} / ${fmtTokens(x.outputTokens ?? 0)}` : ''}</span>
                  <span>{fmtDateTime(x.createdAt)}</span>
                </div>
                <div className="whitespace-pre-wrap">{x.text || <span className="text-muted-foreground">{m.admin_chat_no_text()}</span>}</div>
              </div>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </AdminShell>
  )
}
